import { render, staticRenderFns } from "./ReviewManage.vue?vue&type=template&id=4959b1c8&"
import script from "./ReviewManage.vue?vue&type=script&lang=js&"
export * from "./ReviewManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports